import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
// import qs from 'qs';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    LoginInfo: {},
    UserSystemList: [],
    UserInfo: {},
    currentSystem: { code: '', name: '' },
    SenchaState: false,
    platformname: '',
    CheckState: false,
    Isrz: false
  },
  mutations: {
    setIsrz(state, data) {
      state.Isrz = data;
    },
    setLoginInfo(state, data) {
      state.LoginInfo = data;
    },
    setCheckState(state, data) {
      state.CheckState = data;
    },
    setplatformname(state, data) {
      state.platformname = data;
    },
    setUserSystemList(state, data) {
      state.UserSystemList = data;
    },
    setCurrentSystem(state, data) {
      state.currentSystem = data;
    },
    togglesenchabox(state, data) {
      state.SenchaState = data;
    },
    setUserInfo(state, data) {
      state.UserInfo = data;
    }
  },
  actions: {
    setIsrz(context, params) {
      context.commit('setIsrz', params);
    },
    setCheckState (context, params) {
      context.commit('setCheckState', params);
    },
    setplatformname(context, params) {
      context.commit('setplatformname', params);
    },
    togglesenchabox(context, params) {
      context.commit('togglesenchabox', params);
    },
    userLogin({ commit }, params) {
      return new Promise(resolve => {
        axios({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          url: Vue.prototype.$loginUrl + 'api/login/WebUserLogin', // 运营平台 normal； 配置平台 manager； 建模平台 model；管理平台 admin
          data: {
            identity: 'normal',
            domain: 'www.goeasy.cn',
            terminal: 'web',
            // domain: '',
            // eomid: '',
            // appid: 'A01',
            ...params
            // systype: '1'
          }
        })
          .then(function (response) {
            console.log('获取的用户信息:', response);
            if (response.status === 200) {
              resolve(response.data);
              if (response.data.code === 0) {
                let data = null;
                if (typeof response.data.data === 'string') {
                  data = JSON.parse(response.data.data);
                } else {
                  data = response.data.data;
                }
                localStorage.setItem('UserInfo', JSON.stringify(data.user));
                sessionStorage.setItem('UserInfo', JSON.stringify(data.user));
                commit('setLoginInfo', data.user);
                if (data.systemlst) {
                  var systemlist = data.systemlst;
                  // for (let i = 0; i < data.systemlst.length; i++) {
                  //   var systemlstItem = data.systemlst[i];
                  //   if (systemlstItem.test === '1') {
                  //     console.log('unshow');
                  //   } else {
                  //     systemlist.push(systemlstItem);
                  //   }
                  // }
                  // if (systemlist.length === 0 && data.systemlst.length > 0) {
                  //   systemlist = data.systemlst;
                  // }
                  commit('setUserSystemList', systemlist);
                }
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    loginOut({ commit }, params) {
      commit('setLoginInfo', {});
      commit('setUserSystemList', []);
      localStorage.removeItem('GoeasyServicelst');
      if (window.GEVAR && window.GEVAR.MainController && window.GEVAR.MainController.loginOut) {
        window.GEVAR.MainController.loginOut();
      }
    },
    setCurrentSystem({ commit }, params) {
      commit('setCurrentSystem', params);
    },
    setUserInfo({ commit }, params) {
      commit('setUserInfo', params);
    },
    getUserInfo({ state, commit }, params) {
      if (!params) {
        params = {
          userid: state.LoginInfo.userId,
          getinfo: 2
        };
      }
      return new Promise((resolve, reject) => {
        axios({
          method: 'GET',
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
          url: Vue.prototype.$loginUrl + 'api/login/checktoken',
          params
        }).then((response) => {
          console.log('获取用户所有信息', response);
          if (response.status === 200 && response.data.code === 0) {
            let { data } = response.data;
            if (typeof data === 'string') {
              data = JSON.parse(data);
            }
            commit('setUserInfo', data);
            localStorage.setItem('UserInfo', JSON.stringify(data));
            sessionStorage.setItem('UserInfo', JSON.stringify(data));
            resolve(data);
          } else {
            reject(response);
          }
        }, err => {
          reject(err);
        });
      });
    }
  },
  getters: {
    LoginUserInfo: state => state.LoginInfo,
    UserSystemList: state => state.UserSystemList,
    currentSystem: state => state.currentSystem,
    SenchaState: state => state.SenchaState,
    UserInfo: state => state.UserInfo,
    platformname: state => state.platformname,
    CheckState: state => state.CheckState,
    Isrz: state => state.Isrz
  },
  modules: {}
});
